import gql from "@/api/gql"

const apps = gql`
	query apps($where: appWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		apps(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			list {
				appId
				appName
				urlRouting {
					regexPattern
				}
			}
		}
	}
`

const app = gql`
	query apps($where: appWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		apps(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			list {
				appId
				appName
				urlRouting {
					regexPattern
				}
				email
				emailSenderName
				createdAt
				lastModifiedAt
				createdBy {
					username
				}
				lastModifiedBy {
					username
				}
			}
		}
	}
`

const components = gql`
	query components($where: componentWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		components(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			list {
				id
				name
				status
			}
		}
	}
`

const component = gql`
	query components($where: componentWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		components(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			list {
				id
				name
				vueTemplate
				status
			}
		}
	}
`

const createComponent = gql`
	mutation createComponent($input: createComponentInput!) {
		createComponent(input: $input) {
			status
			createdStatus {
				id
			}
			errors
		}
	}
`

const updateComponent = gql`
	mutation updateComponent($id: String!, $input: updateComponentInput!) {
		updateComponent(id: $id, input: $input) {
			status
			errors
		}
	}
`

const cmsConfig = gql`
	query cmsConfigs($where: CmsConfigWhereInputGraphType) {
		cmsConfigs(where: $where) {
			allowedLocales
			defaultLocale
			analyticsProvidersJsonString
			baseComponentsVariantsJsonString
			componentRoutes {
				path
				name
				component
				metaJsonString
				propsJsonString
				redirect
			}
			endpointsJsonString
			guestLoginCredentials {
				username
				password
			}
			head {
				metaJsonString
				noScript {
					src
					async
					innerHTML
				}
				script {
					src
					async
					innerHTML
				}
				title
			}
			httpHeadersJsonString
			paymentProvidersJsonString
			themeJsonString
		}
	}
`

const createApp = gql`
	mutation createApp($input: createAppInput!) {
		createApp(input: $input) {
			status
			errors
		}
	}
`

const upsertCmsConfig = gql`
	mutation upsertCmsConfig($appId: String!, $config: cmsConfigInput!) {
		upsertCmsConfig(appId: $appId, config: $config) {
			status
			errors
		}
	}
`

const addHostToTenantSettings = gql`
	mutation addHostToTenantSettings($host: String) {
		addHostToTenantSettings(host: $host) {
			status
			errors
		}
	}
`

const updateApp = gql`
	mutation updateApp($appId: String!, $input: updateAppInput!) {
		updateApp(appId: $appId, input: $input) {
			status
			errors
		}
	}
`

const deleteApp = gql`
	mutation deleteApp($appId: String!) {
		deleteApp(appId: $appId) {
			status
			errors
		}
	}
`

const tenantSettings = gql`
	query tenantSettings {
		tenantSettings {
			tenantId
			hosts
		}
	}
`

export const query = {
	apps,
	app,
	components,
	component,
	cmsConfig,
	tenantSettings
}

export const mutation = {
	createComponent,
	deleteApp,
	updateApp,
	updateComponent,
	upsertCmsConfig,
	createApp,
	addHostToTenantSettings
}
